import React from 'react'
import Typography from '../../../../global/typography'
import { ListingItems, ListingsTypeContainer } from './style'
// Helpers
import { isExternalURL } from '../../../../../utils/link.utils'

const ListingItem = (props: any) => {
  let target = '_self'
  let pageLink = ''

  if (props.listingSlug || props.listingUrl) {
    pageLink = props.listingSlug ? props.listingSlug : props.listingUrl
    if (props.listingSlug) {
      pageLink = pageLink.charAt(0) === '/' ? pageLink : `/${pageLink}`
    }
    if (isExternalURL(pageLink)) {
      target = '_blank'
    }
  }
  return (
    <ListingItems data-cy="ListingItem" className="listings__featured-listing">
      {props.formattedDate && (
        <Typography type="captionAlt" className="Listing__Item-Date">
          {props.formattedDate}
        </Typography>
      )}
      {props.listingTitle && (props.listingSlug || props.listingUrl) && (
        <a href={pageLink} target={target}>
          <Typography type="header4" className="Listing__Item-Title">
            {props.listingTitle}
          </Typography>
        </a>
      )}
      {props.listingType && (
        <ListingsTypeContainer>
          <Typography type="captionAlt" className="Listing__Item-Type">
            {props.listingType}
          </Typography>
          {props.listingPublication && (
            <>
              <span className="Listing__Type-Seperator">•</span>
              <Typography type="captionAlt" className="Listing__Item-Publication">
                {props.listingPublication}
              </Typography>
            </>
          )}
        </ListingsTypeContainer>
      )}
    </ListingItems>
  )
}

export default ListingItem
